namespace Account
{
	export class List
		extends ui.tab.TabHTMLPresentation
	{
		private m_List:			Wollmilch.AccountObject[];
		private m_Account:	Wollmilch.AccountObject;
		private m_Table:		Table;

		constructor( account: Wollmilch.AccountObject )
		{
			super();

			this.m_Table		= new Table( { bordered: false, condensed: true, striped: true, hover: true, column_number: 4 } );
			this.m_List			= [];
			this.m_Account	= account;

			this.m_Root.append( this.m_Table.getTable() );
		}

		public LoadList( itemCount: number, vStatusType: string= '' ): List
		{
			const company = app.getAuthenticationManager().getCompany();
			if ( !company )
			{
				return this;
			}

			new Wollmilch.AJAX(
				{
					url: 'account/list/' + company.ID + '/page/0/limit/' + clamp( 5, 50, itemCount ),
					on:
					{
						success: () =>
						{
							return function( text: string ): void
							{
								let obj: Wollmilch.ResponseObject;
								try
								{
									obj = JSON.parse( text );
								}
								catch ( e )
								{
									app.addNotify(
										{
											title: [ ui.h( 3, app.getMessage( "Account.List.ERROR_LOAD_HEAD" ) ) ],
											body: [ ui.text( app.getMessage( "Account.List.ERROR_LOAD_BODY" ) ) ],
											context: 'warning',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								if ( !obj.success )
								{
									app.addNotify(
										{
											title: [ ui.h( 3, app.getMessage( "Account.List.ERROR_LOAD_HEAD" ) ) ],
											body: [ ui.text( app.getMessage( "Account.List.ERROR_LOAD_BODY" ) ) ],
											context: 'info',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								this.m_List = obj.data;

								this.DisplayList();
							};
						}
					}
				}
			).send();

			return this;
		}

		public DisplayList() : void
		{
			this.m_Table.clearBody();

			this.m_Table.createHeaderRow(
				3,
				[
					app.getMessage( "Account.List.HEADER_USER" ),
					'',
					''
				]
			);

			for ( const i in this.m_List )
			{
				const item = this.m_List[ i ];

				() =>
				{
					this.m_Table.createDataRow(
						3,
						[
							$(
								new Button(
									{
										title: item.Username,
										style: 'link',
										on:
										{
											click: () =>
											{
												app.getGlobalTabControl().addTab(
													item.Username,
													new Page( item ),
													true
												);
											}
										}
									}
								).getElement()
							).removeClass( 'btn' ),
							item.Company.toString(),
							( item.ID || "k.A." ).toString()
						]
					);
				};
			}
		}

		public Root(): JQuery
		{
			return this.m_Root;
		}
	}
}
